
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watch } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import { init, ECharts, EChartsOption } from 'echarts'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Table, Charts, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      columns: [],
      data: [],
      spinning: true
    })
    const color = globalsets.getColor()
    pageData.columns = [
      {
        title: '增发时间',
        dataIndex: 'time',
        key: 'time',
        width: '100px'
      },
      {
        title: '实际增发数量(股)',
        dataIndex: 'IssueVol',
        key: 'IssueVol',
        width: '130px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '实际募集净额(元)',
        dataIndex: 'SNINetProceeds',
        key: 'SNINetProceeds',
        width: '150px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '增发价格(元/股)',
        dataIndex: 'IssuePrice',
        key: 'IssuePrice',
        width: '130px',
        slots: { customRender: 'decimal' }
      },
      // {
      //   title: "新股发行(股)",
      //   dataIndex: "xgfx",
      //   key: "xgfx",
      //   slots: { customRender: "peopleCount" }
      // },
      {
        title: '发行方式',
        dataIndex: 'MS',
        key: 'MS',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '股权登记日',
        dataIndex: 'gqdjr',
        key: 'gqdjr'
      },
      {
        title: '增发上市日',
        dataIndex: 'zfssr',
        key: 'zfssr'
      },
      {
        title: '资金到账日',
        dataIndex: 'zjdzr',
        key: 'zjdzr'
      }
    ]
    watch(
      () => (props.pageSourceData || {}).IncreaseDetailData,
      () => {
        const data = (props.pageSourceData || {}).IncreaseDetailData
        pageData.data = handlerData(data)
      },
      { deep: true }
    )
    function handlerData(arr: any) {
      nextTick(() => {
        pageData.spinning = false
      })
      if ((arr || []).length < 1) return []
      arr.sort((a: any, b: any) => {
        return b.ListAnnounceDate - a.ListAnnounceDate
      })
      arr.forEach((item: any, i: number) => {
        item.index = 'Zfmx' + i
        item.time = item.ListAnnounceDate ? window.moment(item.ListAnnounceDate * 1000).format('YYYY-MM-DD') : '—'
        item.gqdjr = item.RightRegDate ? window.moment(item.RightRegDate * 1000).format('YYYY-MM-DD') : '—'
        item.zfssr = item.NewShareListDate ? window.moment(item.NewShareListDate * 1000).format('YYYY-MM-DD') : '—'
        item.zjdzr = item.DateToAccount ? window.moment(item.DateToAccount * 1000).format('YYYY-MM-DD') : '—'
      })
      return arr
    }
    // pageData.data = computed(()=>{
    //    nextTick(()=>{
    //     pageData.spinning = false
    //   })
    //   return myData
    // })
    return {
      ...toRefs(pageData)
    }
  }
})
